import React from "react";
import * as RB from "react-bootstrap";

function BankingInfo({ formData, handleInputChange, setFormData }) {
  return (
    <>
      <h6 className="mt-2">Banking Information</h6>
      <hr className="hr-lg mt-1" />
      <RB.Row>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Bank Name"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Bank Name"
                name="bank_name"
                value={formData.bank_name}
                onChange={handleInputChange}
                required
                maxLength={50}
              />
              <RB.Form.Control.Feedback type="invalid">
                Please Enter Bank Name.
              </RB.Form.Control.Feedback>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Bank Branch"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Bank Branch"
                name="bank_branch"
                value={formData.bank_branch}
                onChange={handleInputChange}
                required
                maxLength={50}
              />
              <RB.Form.Control.Feedback type="invalid">
                Please Enter Bank Branch Name.
              </RB.Form.Control.Feedback>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
      </RB.Row>

      <RB.Row>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Bank Account No"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Bank Account No"
                name="bank_account_no"
                value={formData.bank_account_no}
                onChange={handleInputChange}
                required
              />
              <RB.Form.Control.Feedback type="invalid">
                Please Enter Bank Account No.
              </RB.Form.Control.Feedback>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Bank IFSC Code"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Bank IFSC Code"
                name="bank_ifsc_code"
                value={formData.bank_ifsc_code}
                onChange={handleInputChange}
                required
              />
              <RB.Form.Control.Feedback type="invalid">
                Please Enter Bank IFSC Code.
              </RB.Form.Control.Feedback>
            </RB.FloatingLabel>
          </div>
        </RB.Col>

        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Pan Card No"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Pan Card"
                name="panNo"
                value={formData.panNo}
                onChange={handleInputChange}
                required
                maxLength={10}
              />
            </RB.FloatingLabel>
            <small className="text-muted">
              Note* : As per the Application norms, Please mention your right
              PAN Card no. only, if you enter your wrong PAN card no. then it
              will deducted automatically 20% more amount of your total TDS
              amount.
            </small>
          </div>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default BankingInfo;
